import type {DataValue} from 'schemaDefinition/types';

export const trimDataValue = (value: DataValue): DataValue => {
  if (Array.isArray(value)) {
    return value.map(v => trimDataValue(v)) as DataValue;
  }

  if (typeof value === 'string') {
    return value.trimStart();
  }

  return value;
};
